

import { crmFileSingleSaveAPI } from '@/api/common';

import VueSignaturePad from './VueSignaturePad';
import WkSignatureImage from './Image';

import { valueEquals } from 'element-ui/lib/utils/util';
import { getImageData } from '@/utils';

export default {
  // 签名
  name: 'WkSignaturePad',

  components: {
    VueSignaturePad: VueSignaturePad,
    WkSignatureImage: WkSignatureImage
  },

  props: {
    value: [Object, String], // batchId 交互
    data: String, // 同步数据源
    disabled: Boolean
  },

  data: function data() {
    return {
      options: {
        backgroundColor: '#fff',
        onEnd: this.onEnd,
        minWidth: 1,
        maxWidth: 3
      },
      height: '150px'
    };
  },


  computed: {},

  watch: {
    data: function data(newVal, oldVal) {
      if (!valueEquals(newVal, oldVal)) {
        this.$refs.signaturePad.fromDataURL(newVal);
      }
    }
  },

  created: function created() {},
  mounted: function mounted() {
    if (this.value) {
      this.getData();
    } else {
      this.$emit('input', {});
    }

    this.height = parseInt(this.$refs.wkSignaturePad.clientWidth / 2.6) + 'px';
  },
  beforeDestroy: function beforeDestroy() {},


  methods: {
    getData: function getData() {
      var _this = this;

      getImageData(this.value.url).then(function (data) {
        var img = new Image();
        img.onload = function () {
          var canvasWidth = _this.$refs.signaturePad.canvas.width;
          var width = img.width;
          var ratio = canvasWidth / width;
          console.log(width, canvasWidth, ratio);
          _this.options.minWidth = _this.options.minWidth * ratio;
          _this.options.maxWidth = _this.options.maxWidth * ratio;

          _this.$nextTick(function () {
            _this.$refs.signaturePad.fromDataURL(data.src);
          });
        };
        img.src = data.src;
      }).catch(function () {});
    },
    onEnd: function onEnd() {
      var _this2 = this;

      var _$refs$signaturePad$s = this.$refs.signaturePad.saveSignature(),
          isEmpty = _$refs$signaturePad$s.isEmpty,
          data = _$refs$signaturePad$s.data;

      this.$emit('update:data', data);
      if (!isEmpty) {
        this.$refs.signaturePad.toBlob(function (blob) {
          _this2.uploadFile(blob);
        });
      }
    },
    uploadFile: function uploadFile(blob) {
      var _this3 = this;

      crmFileSingleSaveAPI({
        file: blob,
        batchId: this.value
      }).then(function (res) {
        _this3.$emit('input', res.data);
      }).catch(function () {});
    },
    handleClick: function handleClick(type) {
      if (type === 'clear') {
        this.$refs.signaturePad.clearSignature();
      } else if (type === 'undo') {
        this.$refs.signaturePad.undoSignature();
      }
    }
  }
};